






























































































































































import { Component, Vue } from "vue-property-decorator";
import { mapGetters, mapMutations, mapState } from "vuex";
import { RawLocation } from "vue-router";
import Environment from "@/models/environment";
import AppApiMixin from "../mixins/AppApi.vue";
import { validationMixin } from "vuelidate";

type SidebarItem = {
  mdi: string;
  text: string;
  to: RawLocation;
  use?: boolean;
};

type Divider = { isDivider: boolean; use?: boolean };

@Component({
  components: {
    AppApiMixin
  },
  computed: {
    ...mapState({
      appEnvironment: "appEnvironment",
      sidebar: "sidebar",
    }),
    ...mapGetters("contract", {
      useContract: "useContract",
      contractId: "id",
      contractType: "type",
    }),
    ...mapGetters("organization", { organizationId: "id" }),
    ...mapGetters("user", { passwordChangeRequired: "passwordChangeRequired" }),
    ...mapGetters("appeals", { unreadAppealsCount: "unreadAppealsCount" }),
    ...mapGetters("appeals", { listAppeals: "listAppeals" }),
    ...mapGetters("sidebar", { counterValue: "counterValue" }),
    imageName() {
      switch (this.appEnvironment.constants && this.appEnvironment.constants["BRANCH"]) {
        case 'scs': return 'samara.png';
        case 'vocs': return 'tolyatti.png';
        default: return 'logo.svg';
      }
    },
  },
  methods: {
    ...mapMutations({
      setIsMini: "sidebar/setIsMini"
    }),
    ...mapMutations("sidebar", { setCounterValue: "setCounterValue" }),
  },
  mixins: [validationMixin],
})
class Sidebar extends Vue {
  [x: string]: any;

  lastItem = {
    mdi: "mdi-help-circle",
    text: "Помощь",
    onClick: () => {
      const routeData = this.$router.resolve({name: 'help'});
      window.open(routeData.href, '_blank');
    },
  };

  cv: number;

  public get appealsInfo() {
    return this.unreadAppealsCount ? Array.from(this.unreadAppealsCount).length : '0';
  }

  public get isMini(): boolean {
    return this.sidebar.isMini;
  }

  public get environment(): Environment | null {
    return this.appEnvironment.constants;
  }

  public get items(): (SidebarItem | Divider)[] {
    return [
      {
        mdi: "mdi-script-text",
        text: "Мои договоры",
        to: { name: "myContracts" },
      },
      {
        mdi: "mdi-office-building",
        text: "Карточка организации",
        to: {
          name: "companyCard",
          params: { companyId: this.organizationId },
        },
      },
      {
        mdi: "mdi-card-bulleted",
        text: "Карточка договора",
        to: {
          name: "contractCard",
          params: { contractId: this.contractId },
        },
      },
      { isDivider: true },
      {
        use: !!(this.environment && this.environment["ЛКЮЛОПЛАТА"]),
        mdi: "mdi-credit-card-outline",
        text: "Оплата",
        to: { name: "payments" },
      },
      {
        mdi: "mdi-counter",
        text: "Показания",
        to: { name: "countersValues" },
      },
      {
        use: !(this.environment && this.environment["ЛКОТКЛОБР"]),
        mdi: "mdi-comment-text-multiple",
        text: "Обращения",
        to: {
          name: "appealsByContract",
          params: { contractId: this.contractId }
        },
      },
      {
        use:
          !!(this.environment && this.environment["ЛКЮЛПОЧАС"]) &&
          this.contractType === 3,
        mdi: "mdi-clock-time-nine",
        text: "Почасовое потребление",
        to: {
          name: "hourlyConsumption",
          params: { contractId: this.contractId }
        },
      },
      {
        mdi: "mdi-calendar-month",
        text: "Передача объемов",
        to: { name: "monthlyPlan" },
      },
      { isDivider: true },
      {
        mdi: "mdi-file-document",
        text: "Документы",
        to: {
          name: "documents",
          params: { contractId: this.contractId },
        },
      },
      {
        mdi: "mdi-file-chart",
        text: "Информация",
        to: {
          name: "turnoversAndReports",
          params: { companyId: this.organizationId },
        },
      },
      { isDivider: true },
    ];
  }

  public get showedItems(): (SidebarItem | Divider)[] {
    const { items, useContract, passwordChangeRequired } = this;

    if (passwordChangeRequired) return [];

    if (!useContract) return [items[0]];

    return items
      .map(({ use = true, ...item }) => ({ use, ...item }))
      .filter(({ use }) => use);
  }

  public get badgeColor() {
    // @ts-ignore
    return this.$vuetify.theme.currentTheme.success.lighten1;
  }
}

export default Sidebar;
